export function DeleteContactPerson(organizationID: number, siteGroupID: number, contactPersonID: number): string {
	return `/v1/organizations/${organizationID}/websites/site-groups/${siteGroupID}/contact-persons/${contactPersonID}`;
}

export function Update(organizationID: number, siteGroupID: number): string {
	return `/v1/organizations/${organizationID}/websites/site-groups/${siteGroupID}`;
}

